import {useEffect} from "react";
import {useParams} from 'react-router-dom';

import {ChatInterface} from "@components/ChatInterface";
import {useAgents} from "@hooks/use-agents";

export function AgentChatPage() {
    const {slug} = useParams<{ slug: string }>();
    const {getAgent, loading, refreshAgents} = useAgents();

    const agent = getAgent(slug || '');

    useEffect(() => {
        refreshAgents();
    }, [slug, refreshAgents]);

    useEffect(() => {
        const agentName = agent?.name || 'Pecunio Agent';
        document.title = `${agentName} - Pecunio Agents`;
    }, [agent?.name]);

    if (loading) {
        return (
            <div className="flex items-center justify-center h-full">
                <div className="text-center">
                    <h1 className="text-2xl font-bold mb-4">Loading Agents</h1>
                    <p>Loading agents, please wait...</p>
                </div>
            </div>
        );
    } else if (!agent) {
        return (
            <div className="flex items-center justify-center h-full">
                <div className="text-center">
                    <h1 className="text-2xl font-bold mb-4">Agent Not Found</h1>
                    <p>The requested agent could not be found or is not available.</p>
                </div>
            </div>
        );
    }

    return <ChatInterface agent={agent} loading={loading}/>;
}